import CustomTab from "components/CustomTab";
import { ERR_NETWORK } from "constants/messages";
import { serverGet } from "lib/serverRequest";
import moment from "moment";
import { useSnackbar } from "notistack";
import { useMemo } from "react";
import { useEffect, useState } from "react";
import { openLoading } from "store/reducers/tools";
import CouponsTable from "./CouponsTable";
import ExportReactCSV from "components/ExportReactCSV";
import PaperButton from "components/buttons/PaperButton";
import { Add } from "@mui/icons-material";
import { removeItemArray } from "lib/arrayObject";
import { serverPost } from "lib/serverRequest";
import VoucherAddDialog from "./VoucherAddDialog";
import { downloadVoucher, voucherOptions } from "./DeliveriesForm";

const headers = [
  { label: "Code", key: "code" },
  { label: "Created", key: "created" },
  { label: "Expiry Date", key: "expiry" },
  { label: "Purchaser", key: "purchaser" },
  { label: "Owner", key: "owner" },
  { label: "Voucher Value", key: "voucher_value" },
  { label: "Remaining Boxes", key: "remain_boxes" },
];

export default function CouponsComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState({ label: "Pending", tab: "0" });
  const [update, setUpdate] = useState([]);

  const filterData = useMemo(() => {
    return data?.filter((item) => item.status === activeTab.tab);
  }, [activeTab, data]);

  const errorAction = (res, err) => {
    if (!res && err?.message) {
      enqueueSnackbar(err?.message, { variant: "warning" });
    } else {
      enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
    }
  };

  const loadData = () => {
    openLoading(true);
    serverGet({
      url: "vouchercode",
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          errorAction(res, err);
          return;
        }
        setData(res);
      },
    });
  };

  const handleAdd = (updateData) => {
    if (updateData?.flg === "new") {
      setData((prev) => [updateData.data, ...prev]);
    } else if (updateData?.flg === "update") {
      let update = [];
      data.map((row) => {
        if (row.id === updateData.data.id) return update.push(updateData.data);
        else return update.push(row);
      });
      console.log(update);
      setData(update);
    }
    setOpen(false);
  };

  const handleCancel = (row) => {
    if (!Boolean(row.remain_boxes))
      return enqueueSnackbar("Remaining boxes is zero", { variant: "warning" });
    openLoading(true);
    serverPost({
      url: "vouchercode/cancel",
      data: {
        ...row,
        count: voucherOptions.find((item) => item.id === row.remain_boxes),
      },
      onFinish: (res, err) => {
        openLoading(false);
        const selIndex = data.findIndex((item) => item.id === row.id);
        setData((prev) => [
          ...prev.slice(0, selIndex),
          res,
          ...prev.slice(selIndex + 1),
        ]);
        enqueueSnackbar("Voucher Unlinked from Account.", {
          variant: "success",
        });
        if (res === false) {
          errorAction(res, err);
          return;
        }
      },
    });
  };

  const handleGenerate = (data) => {
    openLoading(true);
    serverPost({
      url: "vouchercode/generate",
      data: { code: data.code, box_count: data?.count?.id },
      onFinish: (res, err) => {
        if (res === false) {
          openLoading(false);
          errorAction(res, err);
          return;
        }
        downloadVoucher(data);
      },
    });
  };

  const handleDelete = (row, index) => {
    openLoading(true);
    serverPost({
      url: "vouchercode/delete",
      data: { voucher_id: row.id },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          errorAction(res, err);
          return;
        }
        setData((prev) => {
          const findIndex = prev.findIndex((item) => item.id === row.id);
          return removeItemArray(prev, findIndex);
        });
      },
    });
  };

  const handleUpdate = (row, index) => {
    setUpdate(row);
    setOpen(true);
  };

  const vouchers = () => {
    let exportData = data?.map((row, key) => ({
      ...row,
      created: moment(row.created_at).format("DD/MM/YYYY"),
      expiry: moment(+row.expiry_date * 1000).format("DD/MM/YYYY"),
      purchaser: row?.email,
      voucher_value: row.count?.id,
    }));
    return exportData;
  };

  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className="flex justify-end mb-4">
        <PaperButton
          onClick={() => setOpen(true)}
          icon={<Add className="text-light-gray" />}
        >
          Add New Voucher
        </PaperButton>
      </div>
      <div className="mb-0.5">
        <div className="flex justify-between items-center">
          <CustomTab
            tabs={[
              { label: "Pending", tab: "0" },
              { label: "Redeemed", tab: "1" },
              { label: "Expired", tab: "2" },
            ]}
            activeTab={activeTab}
            onClick={(tab) => setActiveTab(tab)}
          />
          <ExportReactCSV
            csvHeaders={headers}
            csvData={vouchers()}
            fileName={`voucher-codes.csv`}
          />
        </div>
      </div>
      <CouponsTable
        data={filterData}
        tab={activeTab.tab}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
        onGenerate={handleGenerate}
        onCancel={handleCancel}
      />
      <VoucherAddDialog
        open={open}
        update={update}
        onAdd={handleAdd}
        onClose={() => setOpen(false)}
      />
    </div>
  );
}
